import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/contexts/AuthContext";
import AttendanceRecords from "@/components/attendance/AttendanceRecords";
import AttendanceKiosk from "@/components/attendance/AttendanceKiosk";
import AttendanceEnrollment from "@/components/attendance/AttendanceEnrollment";
import AttendanceDevices from "@/components/attendance/AttendanceDevices";
import { CalendarCheck, Fingerprint, UserPlus, Router } from "lucide-react";

const MANAGER_ROLES = ["managing_director", "executive_director", "general_manager"];

export default function Attendance() {
  const { user } = useAuth();
  const isManager = MANAGER_ROLES.includes(user?.role);
  const [branches, setBranches] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = () => setRefreshKey((k) => k + 1);

  useEffect(() => {
    api.get("/branches").then(({ data }) => setBranches(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="attendance-page">
      <PageHeader
        eyebrow="Administration"
        title="Staff Attendance"
        subtitle="Daily attendance by fingerprint — staff place a finger on the kiosk or the door terminal as they arrive. Managers enroll fingerprints, map door-device IDs and export dated reports."
      />

      <Tabs defaultValue="records">
        <TabsList className="mb-4 flex-wrap h-auto">
          <TabsTrigger value="records" data-testid="att-tab-records">
            <CalendarCheck size={14} className="mr-1.5" /> Records & Reports
          </TabsTrigger>
          <TabsTrigger value="kiosk" data-testid="att-tab-kiosk">
            <Fingerprint size={14} className="mr-1.5" /> Clock Kiosk
          </TabsTrigger>
          {isManager && (
            <TabsTrigger value="enrollment" data-testid="att-tab-enrollment">
              <UserPlus size={14} className="mr-1.5" /> Enrollment
            </TabsTrigger>
          )}
          {isManager && (
            <TabsTrigger value="devices" data-testid="att-tab-devices">
              <Router size={14} className="mr-1.5" /> Devices
            </TabsTrigger>
          )}
        </TabsList>
        <TabsContent value="records">
          <AttendanceRecords isManager={isManager} branches={branches}
            refreshKey={refreshKey} onChanged={refresh} />
        </TabsContent>
        <TabsContent value="kiosk">
          <AttendanceKiosk onChanged={refresh} />
        </TabsContent>
        {isManager && (
          <TabsContent value="enrollment">
            <AttendanceEnrollment isManager={isManager} refreshKey={refreshKey} onChanged={refresh} />
          </TabsContent>
        )}
        {isManager && (
          <TabsContent value="devices">
            <AttendanceDevices branches={branches} refreshKey={refreshKey} onChanged={refresh} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
